module.exports = __webpack_public_path__ + "img/medal_3.fa12c2da.png";